import {useNavigate, useParams} from "react-router-dom";
import {ViewEaAccreditation} from "./ViewEaAccreditation";
import React, {useEffect, useState} from "react";
import {useIntl} from "react-intl";
import Loading from "../../general/Loading";
import {AlertError} from "../../bootstrap/AlertError";
import {AlertSuccess} from "../../bootstrap/AlertSuccess";
import {SubTemplate} from "../../general/SubTemplate";
import {Col, Container, Row, Toast, ToastContainer} from "react-bootstrap";
import {accreditateEntity, cessateEntity, getEntityAccreditation, getEntityAccreditationByNif} from "../../../rest/entity";
import {getDistricts} from "../../../rest/administrativeDivision";
import {DetailEntityAccreditationMenu} from "./DetailEntityAccreditationMenu";
import {listEntityDocuments} from "../../../rest/document";
import {EntityRevokedAlert} from "../EntityRevokedAlert";
import { EntityState } from "../../../models/EntityState";
import { EaCessationModal } from "../EaCessationModal";
import { FaCheck } from "react-icons/fa";

export function DetailEntityAccreditationPage() {
    const {entityNIPC} = useParams();
    const intl = useIntl();
    const navigate = useNavigate();

    const [lsItem, setLsItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [accreditation, setAccreditation] = useState();
    const [districts, setDistricts] = useState();
    const [documents, setDocuments] = useState();
    const [showCessationModal, setShowCessationModal] = useState(false);
    const [showCessationToast, setShowCessationToast] = useState(false);
    const [showApprovalToast, setShowApprovalToast] = useState(false);

    async function fetchData() {
        try {
            let [
                {data: eaAccreditation},
                {data: dist},
                { data: entityDocuments },
            ] = await Promise.all([
                await (entityNIPC === undefined ? getEntityAccreditation() : getEntityAccreditationByNif(entityNIPC)),
                await getDistricts(true),
                await listEntityDocuments({entityNif: entityNIPC}),
            ]);
            setAccreditation(eaAccreditation);
            setDistricts(dist);
            setDocuments(entityDocuments);
        } catch (er) {
            setError(er);
        } finally {
            setLoading(false);
        }
    }

    function checkLocalStorageItems() {
        [].forEach((s) => {
            if (sessionStorage.getItem(s)) setLsItem(s);
        });
    }


    useEffect(() => {
        fetchData();
        checkLocalStorageItems();
    }, []);

    async function cessate() {
        try{
          await cessateEntity(entityNIPC);
          setShowCessationToast(true);
          fetchData();
          setShowCessationModal(false);
        } catch (error) {
          setError(error);
        }
      }

    function closeAllToasts() {
        setShowCessationToast(false);
        setShowApprovalToast(false);
    }

    if(loading) return <Loading/>

    function getSaveToastInformation(message) {
    return (
        <ToastContainer className='fixed-top'>
          <Toast autohide delay={3000} show={showCessationToast || showApprovalToast} onClose={() => closeAllToasts()}>
            <Toast.Header>
              <strong className='me-auto text-primary'>
              <span className='mr-2'>
                <FaCheck />
              </span>
                {message}
              </strong>
            </Toast.Header>
          </Toast>
        </ToastContainer>
    );
  }

    return (
        <SubTemplate titleId={'eaAccreditation.View'}  hasBackButton>

            <EaCessationModal
                show={showCessationModal}
                setShow={setShowCessationModal}
                entityDetails={accreditation.entity}
                submit={cessate} 
            />

            <Container>
                <AlertError error={error} />
                {lsItem && <AlertSuccess lsItem={lsItem} />}
                {accreditation != null && accreditation?.entity?.revoked === true &&
                    <Row>
                        <Col>
                            <EntityRevokedAlert/>
                        </Col>
                    </Row>}
                {showCessationToast && getSaveToastInformation(
                    intl.formatMessage({ id: 'eaAccreditation.cessation.cessate.toastMessage' })
                )}
                {showApprovalToast && getSaveToastInformation(
                    intl.formatMessage({ id: 'eaAccreditation.cessation.approve.toastMessage' })
                )}

                <Row>
                    <Col md='10' className='mb-5 summaryTabs'>
                        <ViewEaAccreditation accreditation={accreditation} documents={documents} districtOptions={districts}/>
                    </Col>
                    <Col md="2">
                        <DetailEntityAccreditationMenu accreditation={accreditation} setShowCessationModal={setShowCessationModal}/>
                    </Col>
                </Row>

            </Container>
        </SubTemplate>
    );
}

